module.exports = __webpack_public_path__ + "static/0067-77ec1d2caf17e63333392fb801b250b2.png";